import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes safely */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Formatters extracted to @trackizy/formatters so mobile can share them.
export {
  formatSpeed,
  formatDistance,
  formatCoord,
  formatDuration,
  formatVoltage,
  getVehicleStatus,
  isStationaryFix,
} from '@trackizy/formatters';

// STATUS_CONFIG moved to @trackizy/design-tokens so mobile can share it.
export { STATUS_CONFIG } from '@trackizy/design-tokens';
